export const users = {
	david: '6a951a9f-866f-455b-a5ec-5e74ed1875d5',
	david_norstat: '065f1cd7-2f1a-4e8e-961a-746482e44839',
	jarle_kettle: '061a150c-8876-4506-ae7e-3bd4fec9d4b5',
	jarle: '66e6992d-b7fa-474d-8c5f-bbd18399baa2',
	ulrik_kettle: '9593ae1a-c338-4cd7-81ba-76140dc70620',
	ulrik: 'a9e3193c-b2b3-4c44-b83e-e125b4efa3c1',
	kissor: 'dcbc95c8-3322-46f7-8d1b-b62523f9b4fa',
	espen_kettle: '85381395-e553-4612-85b2-dc6e5052d7b8',
	espen: 'dbf36936-5fbe-44ab-94bf-266c1d721e0a',
	mats: 'c7ba42c6-2cff-48a8-9d4b-0393652dcdb3',
	mathias: '0f8c9bd6-e5c9-4d80-8d02-ccdfe78c1e7c',
	ali: '9f602258-025f-4ed9-8b7a-1d82465f38be',
	torolf: '8f7691db-d67f-4864-a6d0-bb41fe5ff6d3',
	oskar: '4820029a-4d71-4271-b3e7-2a0c7f9f251d',
}
